document.addEventListener('click', function(e){

  const level1Tab = e.target.closest('.level-1-tab');

  if(level1Tab){

    const selectedTab = level1Tab.dataset.tab;

    document.querySelectorAll('.level-1-tab').forEach(tab=>{
      tab.classList.remove('active');
    });

    level1Tab.classList.add('active');

    const level2Items = document.querySelectorAll('.level-2-item');

    let firstVisibleCollection = null;

    level2Items.forEach(item => {

      if(item.dataset.parent === selectedTab){

        item.classList.remove('hidden');

        if(!firstVisibleCollection){
          firstVisibleCollection = item.dataset.collection;
        }

      } else {

        item.classList.add('hidden');
        item.classList.remove('active');

      }

    });

    document.querySelectorAll('.product-group').forEach(group => {

      if(group.dataset.collection === firstVisibleCollection){
        group.classList.remove('hidden');
      } else {
        group.classList.add('hidden');
      }

    });

    const firstVisibleLevel2 = document.querySelector(
      '.level-2-item:not(.hidden)'
    );

    if(firstVisibleLevel2){
      firstVisibleLevel2.classList.add('active');
    }
  }

  const level2Tab = e.target.closest('.level-2-item');

  if(level2Tab){

    const collectionHandle = level2Tab.dataset.collection;

    document.querySelectorAll('.level-2-item').forEach(item=>{
      item.classList.remove('active');
    });

    level2Tab.classList.add('active');

    document.querySelectorAll('.product-group').forEach(group=>{

      if(group.dataset.collection === collectionHandle){
        group.classList.remove('hidden');
      } else {
        group.classList.add('hidden');
      }

    });
  }

});